<template>
  <div>
    <p class="element">Przeciągnij i upuść, aby zmienić kolejność</p>
    <div v-if="errorMessage">
      <p class="text-danger element">{{ errorMessage }}</p>
    </div>
    <div v-if="successMessage">
      <p class="text-success element">{{ successMessage }}</p>
    </div>
    <draggable
      v-model="myArray"
      group="people"
      @start="drag = true"
      @end="drag = false"
    >
      <div
        v-for="(element, index) in myArray"
        :key="element.id"
        class="element-container btn-outline-dark"
      >
        <p class="element">
          {{ element.name }}
          <span class="badge badge-danger">{{ index + 1 }}</span>
        </p>
      </div>
    </draggable>
    <div class="text-center">
      <button
        v-on:click="changeOrderHandler"
        class="btn btn-outline-dark updateButton"
      >
        Zaktualizuj kolejność
      </button>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import axios from "../../axios.js";

export default {
  components: {
    draggable,
  },
  name: "services-order",
  computed: {},
  created() {
    this.getServices();
  },
  data: function() {
    return {
      myArray: [],
      errorMessage: "",
      successMessage: "",
    };
  },
  methods: {
    getServices() {
      const url = `api/serviceCategory/services`;
      axios
        .get(url, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.myArray = response.data.map((item) => {
            return { id: item.id, name: item.name };
          });
        })
        .catch(() => {
          this.errorMessage = "Nie udało się wczytać kategorii";
        });
    },
    changeOrderHandler() {
      const ids = this.myArray.map((item) => item.id);

      const url = "api/serviceCategory/priority";
      const body = JSON.stringify({ services: ids });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      axios
        .post(url, body, config)
        .then((res) => {
          this.successMessage = res.data.message;
          setTimeout(() => (this.successMessage = ""), 3000);
        })
        .catch(() => {
          this.errorMessage = "Wystąpił błąd przy zmianie kolejności";
          setTimeout(() => (this.errorMessage = ""), 3000);
        })
        .finally(() => {
          this.scrollToTop();
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
div.container {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  text-align: center;
}
div.element-container {
  margin: 0 auto;
  border-radius: 5px;
  margin-top: 10px;
  justify-content: center;
  display: flex;
  height: 30px;
  width: 300px;
}
p.element {
  text-align: center;
}
.updateButton {
  width: 300px;
  margin-top: 30px;
}
.updateButton:hover {
  margin-top: 30px;
}
.badge-danger {
  background: #fb8928;
  color: #090741;
  border-radius: 5px;
  width: 13px;
  text-align: center;
}
.btn-outline-dark:hover {
  background: #fb8928 !important;
}
</style>
